<section class="sign-in">
    <div class="wrapper">
        <div class="col w55" [class.is-admin]="authType === 'gerenciador'">
            <h2 class="ai-title">
                {{authType === 'gerenciador' ? 'Administrador' : 'Imobiliária'}}
            </h2>
            <img src="assets/admin-illustration.gif" alt="Imobiliária" *ngIf="authType === 'gerenciador'">
            <img src="assets/imobiliaria-illustration.gif" alt="Admin" *ngIf="authType === 'imobiliaria'">
        </div>
        <div class="col w45">
            <div class="login-logo">
                <img src="assets/logo.png" alt="Nome da empresa">
            </div>
            <h1 class="login__title">
                {{isLogin ? 'Seja bem-vindo' : 'Recuperar senha'}}
            </h1>
            <h2 class="login__description">
                Faça o login informando as informações abaixo.
            </h2>
            <form class="login-form" (ngSubmit)="login(form)" #form="ngForm" *ngIf="isLogin">

                <div class="loading" *ngIf="loading">
                    <mat-spinner></mat-spinner>
                </div>

                <ng-container *ngIf="!loading">
                    <mat-form-field class="login-form-control">
                        <input matInput placeholder="E-mail" [(ngModel)]="usuario.email" type="email" name="email"
                            required>
                    </mat-form-field>

                    <mat-form-field class="login-form-control">
                        <input matInput placeholder="Senha" [(ngModel)]="usuario.senha" type="password" name="senha"
                            required>
                    </mat-form-field>

                    <button mat-flat-button color="primary" type="submit">
                        Entrar
                    </button>
                </ng-container>
            </form>


            <form class="login-form" (ngSubmit)="esqueceuSenha(formResetPassword)" #formResetPassword="ngForm"
                *ngIf="!isLogin">

                <div class="loading" *ngIf="loading">
                    <mat-spinner></mat-spinner>
                </div>

                <ng-container *ngIf="!loading">
                    <mat-form-field class="login-form-control">
                        <input matInput placeholder="E-mail" [(ngModel)]="usuario.email" type="email" name="email"
                            required>
                    </mat-form-field>

                    <button mat-flat-button color="primary" type="submit">
                        Recuperar
                    </button>
                </ng-container>
            </form>

            <a (click)="isLogin = !isLogin">{{isLogin ? 'Esqueci minha senha' : 'Voltar ao login'}}</a>
        </div>
    </div>
</section>